export enum SelectableFleetLoyaltyTypes {
    RECURRENT_LOYALTY = "Fidelizada por recurrencia",
    SPOT_LOYALTY = "Spot",
    DEDICATED_FLEET = "Dedicada",
    DEFAULT = "Default"
}